var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"currency"},[_c('vue-numeric',{attrs:{"currency":"$","separator":".","read-only":true,"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }